<template>
  <div>
    <div 
      v-if="staff == null" 
      class="col-xs-12 text-center">
      <i class="fa fa-spinner fa-spin fa-2x"/>
    </div>
    <div v-else>
      <div class="col-sm-5 col-md-4 col-lg-3">
        <div class="box">
          <div class="box-header b-b">
            <h3>Update Profile</h3>
          </div>

          <div class="p-a">
            <div 
              class="item dark pointer" 
              @click="showImageForm">
              <a><img 
                :src="image_url" 
                class="w-full"></a>
              <div class="item-overlay black-overlay w-full">
                <a class="center text-md"><i class="material-icons">&#xE412;</i></a>
              </div>
              <div class="top item-overlay text-right p-x-xs"/>
            </div>
          </div>

          <!-- FORM -->
          <staff-form
            ref="form"
            :staff="staff" 
            class="p-a"
            @submitSuccess="updateSuccessCallback"
            @submitFailed="updateFailedCallback"
            @beforeSubmit="onSubmit"/>

          <div
            v-if="canManageStaff"
            class="row no-gutter b-t text-right">
            <div class="p-a">
              <button 
                :disabled="loading" 
                class="md-btn md-raised w-xs green" 
                @click="submit">Save</button>
            </div>
          </div>

        </div>
      </div>
    
      <div class="col-sm-7 col-md-8 col-lg-9">
        <div class="box">
          <div class="box-header b-b">
            <h3>{{ staff.name }}'s Attendance</h3>
          </div>
          <div class="box-body">
            <div class="streamline b-l m-l">
              <div 
                v-for="attendance in attendanceList" 
                :key="attendance.id" 
                class="sl-item">
                <div class="sl-content">
                  <div class="sl-date text-muted">{{ getFormattedDate(attendance.time_in) }}</div>
                  <div> In <span class="text-muted">{{ getFormattedTime(attendance.time_in) }}</span> - Out <span class="text-muted">{{ getFormattedTime(attendance.time_out) }}</span> </div>
                </div>
              </div>
              <infinite-loading 
                ref="infiniteLoading" 
                :on-infinite="getStaffAttendance"/>
            </div>
          </div>
        </div>
      </div>

      <vue-dropzone-popup 
        id="staff-image" 
        ref="staffImage"
        :pk-id="staff.id"
        :url="uploadUrl"
        label="Upload Image"
        @uploadSuccess="uploadSuccess"/>
    </div>
  </div>
</template>

<script>
import PermissionMixin from '../../staff/staff-permission';
import staffForm from './_form.vue';

export default {
    components: {
        staffForm,
    },

    mixins: [PermissionMixin],

    props: {
        staffId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            staff: null,
            attendanceList: [],
            page: 1,
            limit: 15,
            loading: false,
        };
    },

    computed: {
        uploadUrl() {
            return Laroute.route('franchise.staff.addMedia');
        },
        image_url() {
            return this.staff.media_urls.length
                ? this.staff.media_urls[0].original
                : '/img/placeholder-pic.jpg';
        },
    },

    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.getStaff();
        },
        getStaff() {
            let api = Laroute.route('franchise.staff.show', {
                id: this.staffId,
            });
            this.$http.get(api).then(res => {
                this.setStaff(res.data.data);
            });
        },

        submit() {
            if (this.$refs.form) {
                this.$refs.form.submit();
            }
        },

        setStaff(data) {
            this.staff = data;
        },

        getFormattedDate(date) {
            return moment(date).format('ddd Do MMMM YYYY');
        },

        getFormattedTime(date) {
            return moment(date).format('h:mm a');
        },

        updateSuccessCallback(data) {
            toastr.success('Staff has been updated successfully');
            this.setStaff(data);
            this.loading = false;
        },

        onSubmit() {
            this.loading = true;
        },

        updateFailedCallback() {
            this.loading = false;
        },

        showImageForm() {
            this.$refs.staffImage.showForm();
        },

        getStaffAttendance() {
            let api = Laroute.route('franchise.staff.attendance', {
                id: this.staffId,
            });

            let options = {
                params: {
                    page: this.page,
                    limit: this.limit,
                },
            };

            var vm = this;
            setTimeout(() => {
                vm.$http.get(api, options).then(res => {
                    let data = res.data.data;
                    let length = res.data.count;
                    let maxPage = Math.ceil(length / vm.limit);

                    if (data.length) {
                        vm.attendanceList = vm.attendanceList.concat(data);
                        if (vm.page >= maxPage) {
                            vm.$refs.infiniteLoading.$emit(
                                '$InfiniteLoading:loaded',
                            );
                            vm.$refs.infiniteLoading.$emit(
                                '$InfiniteLoading:complete',
                            );
                        } else {
                            vm.$refs.infiniteLoading.$emit(
                                '$InfiniteLoading:loaded',
                            );
                            // somehow page not scroll up automatically that cause infine load keep running
                            let y = $(window).scrollTop();
                            $(window).scrollTop(y - 70);
                        }
                        vm.page++;
                    } else {
                        vm.$refs.infiniteLoading.$emit(
                            '$InfiniteLoading:complete',
                        );
                    }
                });
            }, 500);
        },

        uploadSuccess(file, response) {
            this.setStaff(response.data);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/outlet/staff/staff_profile.vue